import angular from 'angular';
import uiRouter from 'angular-ui-router';
import OrderAndPayPickupPointComponent from './pickupPoint.component';
import OrderAndPayPickupPointEditPickupPoint from './edit/edit';

const OrderAndPayPickupPointModule = angular.module('tinaba.components.services.orderAndPay.pickupPoint', [
  uiRouter,
  OrderAndPayPickupPointEditPickupPoint.name
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('services.orderAndPay.pickupPoint', {
      url: '/pickupPoint',
      template: '<order-and-pay-pickup-point></order-and-pay-pickup-point>'
    });
})

.component('orderAndPayPickupPoint', OrderAndPayPickupPointComponent);

export default OrderAndPayPickupPointModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAndPay/pickupPoint/pickupPoint.js
 **/